import { useRoot } from "./useRoot";

/**
 * Obtains current route
 */
export function useRoute() {
  const root = useRoot();
  return root.$route;
}
